import { locationFacade } from '@goparrot-dashboard-api/orchestration';

export const getLocations = (merchantId: string) =>
  function* () {
    return yield locationFacade.list(merchantId);
  };
